import { Routes, Route } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Layout from "./Components/Layout";
import Settings from "./Pages/Setting/SecuritySettings";
import NotFound from "./utils/NotFound";
import Login from "./Pages/Login/Login";
import PublicRoute from "./Route/PublicRoute";
import PrivateRoute from "./Route/PrivateRoute";
import Users from "./Pages/User/Users";
import Upi from "./Pages/qrCode/upi/Upi";
import NewUpiForm from "./Pages/qrCode/upi/components/NewUpiForm";
import Kyc from "./Pages/qrCode/kyc/Kyc";
import NewKycForm from "./Pages/qrCode/kyc/components/NewKycForm";
import Token from "./Pages/qrCode/token/Token";
import NewTokenForm from "./Pages/qrCode/token/components/NewTokenForm";
import DepositInr from "./Pages/transaction/Deposit/inr/Inr";
import DepositToken from "./Pages/transaction/Deposit/token/Token";
import P2pInr from "./Pages/p2p/inr/components/AllInr";
import P2pToken from "./Pages/p2p/token/components/AllToken";
import WithdrawalInr from "./Pages/transaction/Withdrawal/inr/Inr";
import WithdrawalToken from "./Pages/transaction/Withdrawal/token/Token";
import AllBanner from "./Pages/Banner/AllBanner";
import CreateBanner from "./Pages/Banner/CreateBanner";
import AllBuyInr from "./Pages/BuyInr/AllBuyInr";
import CreateBuyInr from "./Pages/BuyInr/CreateBuyInr";
import CreateP2PSellOrder from "./Pages/P2PSellOrder/CreateP2PSellOrder";
import CreateP2PBuyOrder from "./Pages/P2PSellOrder/CreateP2PBuyOrder";
import AllP2POrders from "./Pages/P2PSellOrder/AllP2POrders";
import AllAppSettings from "./Pages/AppSettings/AllAppSettings";
import CreateAppSetting from "./Pages/AppSettings/CreateAppSetting";
import AllSellList from "./Pages/SellManagement/AllSellList";
import AllBuyOrders from "./Pages/P2PSellOrder/AllBuyOrders";
import AllSellOrders from "./Pages/P2PSellOrder/AllSellOrders";
import UsdtSellList from "./Pages/SellManagement/UsdtSellList";
import TokenSellList from "./Pages/SellManagement/TokenSellList";
import ReferralChainPage from "./Pages/Referral/Referralchainpage";
import AgentShip from "./Pages/AgentShip/AgentShip";
import AllSupportTickets from "./Pages/SupportTickets/AllSupportTickets"

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route element={<PublicRoute />}>
        <Route path="/auth/login" element={<Login />} />
      </Route>

      {/* Private routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="/settings/security" element={<Settings />} />
          <Route path="/users" element={<Users />} />
          {/* <Route path="/qr-code/upi" element={<Upi />} /> */}
          {/* <Route path="/qr-code/upi/create" element={<NewUpiForm />} /> */}
          <Route path="/qr-code" element={<Token />} />
          <Route path="/qr-code/create" element={<NewTokenForm />} />
          {/* <Route path="/qr-code/kyc" element={<Kyc />} /> */}
          {/* <Route path="/qr-code/kyc/create" element={<NewKycForm />} /> */}
          <Route path="/deposit/token" element={<DepositInr />} />
          <Route path="/deposit/usdt" element={<DepositToken />} />
          <Route
            path="/transaction/withdrawal/inr"
            element={<WithdrawalInr />}
          />
          <Route
            path="/transaction/withdrawal/token"
            element={<WithdrawalToken />}
          />
          {/* <Route path="/p2p/inr" element={<P2pInr />} />
          <Route path="/p2p/token" element={<P2pToken />} /> */}
          <Route path="/banner" element={<AllBanner />} />
          <Route path="/banner/create" element={<CreateBanner />} />
          <Route path="/buy-inr" element={<AllBuyInr />} />
          <Route path="/buy-inr/create" element={<CreateBuyInr />} />
          <Route
            path="/p2p/sell-order/create"
            element={<CreateP2PSellOrder />}
          />
          <Route path="/p2p/buy-order/create" element={<CreateP2PBuyOrder />} />
          <Route path="/p2p/all-orders" element={<AllP2POrders />} />
          <Route path="/p2p/buy-order-list" element={<AllBuyOrders />} />
          <Route path="/p2p/sell-order-list" element={<AllSellOrders />} />
          <Route path="/agent-ship" element={<AgentShip />} />
          <Route path="/app-settings" element={<AllAppSettings />} />
          <Route path="/support-tickets" element={<AllSupportTickets />} />
          <Route path="/app-settings/create" element={<CreateAppSetting />} />
          <Route path="/sells/usdt" element={<UsdtSellList />} />
          <Route path="/sells/token" element={<TokenSellList />} />

          <Route path="*" element={<NotFound />} />
          <Route path="/users/referral-chain/:userId/:userName" element={<ReferralChainPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
